<template>
    <div class="navbar">
        <el-aside :width="isCollapse ? '64px' : '200px'">
            <el-menu
                    background-color="#333744"
                    text-color="#fff"
                    active-text-color="#409EFF"
                    :unique-opened="true"
                    :collapse="isCollapse"
                    :collapse-transition="false"
                    :router="true"
                    :default-active="activeMenu"
            >
                <el-submenu
                        :index="item.id + ''"
                        v-for="item in menuList"
                        :key="item.id"
                >
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span>{{ item.name }}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item
                                :index="resolvePath(subItem.path)"
                                v-for="subItem in item.children"
                                :key="subItem.id"
                        >
                            <i :class="subItem.icon"></i>
                            {{subItem.name}}
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </el-aside>
    </div>
</template>

<script>
    export default {
        name: "NavbarView",
        data() {
            return {
                isCollapse: false,
                menuList: [],
                hasLoaded: false // 添加加载状态标识
            }
        },
        computed: {
            // 计算当前激活的菜单
            activeMenu() {
                const route = this.$route
                const { meta, path } = route
                if (meta.activeMenu) {
                    return meta.activeMenu
                }
                return path
            }
        },
        created() {
            this.getMenuData()
        },
        methods: {
            resolvePath(routePath) {
                if (routePath.startsWith('/')) {
                    return routePath
                }
                return `/${routePath}`
            },

            async getMenuData() {
                // 如果已经加载过，直接返回
                if (this.hasLoaded && this.menuList.length > 0) {
                    return
                }

                // 尝试从 sessionStorage 获取缓存的菜单数据
                const cachedMenu = sessionStorage.getItem('cachedMenu')
                if (cachedMenu) {
                    this.menuList = JSON.parse(cachedMenu)
                    this.hasLoaded = true
                    return
                }

                console.log('token---------', sessionStorage.getItem('token'))
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    uid: sessionStorage.getItem('uid'),
                }

                let roles = JSON.parse(sessionStorage.getItem('roles') || '[]')
                let role_ids = []
                console.log('roles', roles)
                for(let i = 0; i < roles.length; i++) {
                    console.log('id----', roles[i].id)
                    role_ids.push(roles[i].id)
                }
                param.role_id = role_ids.join(',')

                try {
                    const res = await this.$axios.shopModuleList(param)
                    if (res.code == 200) {
                        this.menuList = res.data
                        this.hasLoaded = true
                        // 缓存菜单数据
                        sessionStorage.setItem('cachedMenu', JSON.stringify(res.data))
                    }
                } catch (error) {
                    console.error('获取菜单数据失败:', error)
                }
            },

            toggleCollapse() {
                this.isCollapse = !this.isCollapse
            },

            // 清除缓存的方法（在登出或切换用户时调用）
            clearMenuCache() {
                this.hasLoaded = false
                this.menuList = []
                sessionStorage.removeItem('cachedMenu')
            }
        }
    }
</script>
